let numericstr = "0123456789";
let upperstr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
let lowerstr = "abcdefghijklmnopqrstuvwxyz";
let symbolstr = "!#$%&'*+-/=?^_`{|}\".";
let symbolstr2 = "!#$%&'*+-/=?^_`{|}\".@";
let symbolstr3 = "+-.:/";
let symbolstr4 = "-_.!*'():?#/?:@%$&+,;=";
let symbolstr5 = "$|";
let melodyStampStr = "CDEFGABRLTOVQcdefgabrltovq+-.&<>@,";
let OBJECT_NAME_MAX = 50;
let DOMAINE_NAME_MAX = 50;
let COUNTRY_CODE_MAX = 3;
let fullKana = "アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン" +
    "ガギグゲゴザジズゼゾダヂヅデドバビブベボパピプペポヴヷヺ" +
    "ァィゥェォッャュョ。、ー「」・";
let domainNameRegex = /^[a-zA-Z0-9](?!.*--)(?:[a-zA-Z0-9-]{0,48}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,48}[a-zA-Z0-9])?)*$/;
export default {
    isValidForPassword(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        if (checkString.length < 8) {
            return false;
        }
        if (checkString.length > OBJECT_NAME_MAX) {
            return false;
        }
        let existNum = false;
        let existUpper = false;
        let existLower = false;

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                existNum = true;
            } else if (upperstr.indexOf(character) >= 0) {
                existUpper = true;
            } else if (lowerstr.indexOf(character) >= 0) {
                existLower = true;
            } else if (symbolstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        if ((existNum == true) & (existUpper == true) & (existLower == true)) {
            return true;
        } else {
            return false;
        }
    },
    isValidForDomainName(checkString) {
        if ((checkString == null) || (checkString == "") || (checkString.length > DOMAINE_NAME_MAX)) {
            return false;
        }
        return domainNameRegex.test(checkString);
    },
    isValidForPhoneNumber(inputString, countryCode) {
        let checkString = inputString
        let externalNumber = true;
        if (inputString.startsWith("#")) {
            checkString = inputString.replace("#", "");
            externalNumber = false;
        }
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        if (externalNumber) {
            if (countryCode == "JPN") {
                if ((checkString.length < 10) || (checkString.length > 11)) {
                    return false;
                }
            } else {
                if (checkString.length > 15) {
                    return false;
                }
            }
        }
        return true;
    },
    isValidForMobilePhoneNumber(inputString, countryCode) {
        // TODO: countryCode except for JPN is not implemented currently
        if (inputString.length != 11) {
            return false;
        }
        let re = /^0[1-9]0\d\d\d\d\d\d\d\d/;
        let index = inputString.search(re);
        return (index == 0);
    },
    isValidForZipCode(checkString, countryCode) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        if (countryCode == "JPN") {
            if (checkString.length !== 7) {
                return false;
            }
        } else {
            if (checkString.length < 5) {
                return false;
            }
        }
        return true;
    },
    isValidForMailaddress(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        if (checkString.indexOf("@") < 0) {
            return false;
        }
        if (checkString.indexOf("@") == 0) {
            return false;
        }

        let mailAddress = checkString.split("@");

        for (let i = 0; i < mailAddress[0].length; i++) {
            let character = mailAddress[0].charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr2.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }

        if (mailAddress.length == 2) {
            return this.isValidForDomainName(mailAddress[1]);
        } else {
            return false;
        }
    },
    isValidForUserName(checkString) {
        if (checkString.length > OBJECT_NAME_MAX) {
            return false;
        }
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidForCountryCode(checkString) {
        if (checkString.length > COUNTRY_CODE_MAX) {
            return false;
        }

        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (upperstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;

    },
    isValidForGroupAndTalkgroupName(checkString) {
        if (checkString.length > OBJECT_NAME_MAX) {
            return false;
        }
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (character == "　") {
                return false;
            }
        }
        return true;
    },
    isValidForDisplayName(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        if (checkString.indexOf("\\") >= 0) {
            return false;
        } else {
            return true;
        }
    },
    isValidForNumeric(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidForAlphabetName(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        let spaceString = " ";
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (spaceString.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidForUrlScheme(checkString) {
        if (checkString.length > OBJECT_NAME_MAX) {
            return false;
        }
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr3.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidAlphabetName(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidUrl(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr4.indexOf(character) >= 0) {
                ;
            } else if (numericstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidToken(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr4.indexOf(character) >= 0) {
                ;
            } else if (numericstr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidForHalfWideLetter(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }

        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else if (upperstr.indexOf(character) >= 0) {
                ;
            } else if (lowerstr.indexOf(character) >= 0) {
                ;
            } else if (symbolstr4.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidFilePathFormat(checkString) {
        if (checkString == null) {
            // In the empty case, default file path format is used at server side
            return true;
        }
        if (checkString == "") {
            // In the empty case, default file path format is used at server side
            return true;
        }
        let nameList = checkString.split('/');
        let initialFlag = true;
        for (let name of nameList) {
            let result = this.isValidFilePathFormatElem(name, initialFlag);
            if (!result) {
                return false;
            }
            initialFlag = false;
        }
        return true;
    },
    isValidFilePathFormatElem(elem, acceptEmpty) {
        if (elem == "") {
            return acceptEmpty;
        }
        let length = elem.length;
        if (length != elem.trim().length) {
            return false;
        }
        let invalidCharacterSet = new Set();
        invalidCharacterSet.add('\\');
        //        invalidCharacterSet.add('/'); // this doesn't happen because it's split
        invalidCharacterSet.add(':');
        invalidCharacterSet.add('*');
        invalidCharacterSet.add('?');
        invalidCharacterSet.add('"');
        invalidCharacterSet.add('<');
        invalidCharacterSet.add('>');
        invalidCharacterSet.add('|');

        for (let index = 0; index < length; index++) {
            // field doesn't start, which means normal string
            if ((elem.charAt(index) != '$') || (index >= length - 1)) {
                if (invalidCharacterSet.has(elem.charAt(index))) {
                    return false;
                }
                continue;
            }
            // field doesn't start, which means normal string
            index++;
            if (elem.charAt(index) != '{') {
                if (invalidCharacterSet.has(elem.charAt(index))) {
                    return false;
                }
                continue;
            }
            // field starts but doesn't end
            index++;
            if (index >= length - 1) {
                return false;
            }
            // field ends with no element
            if (elem.charAt(index) == '}') {
                return false;
            }
            // check whether the field ends correctly
            index++;
            let notFound = true;
            for (; index < elem.length; index++) {
                if (elem.charAt(index) == '}') {
                    notFound = false;
                    break;
                }
                // another field starts without finishing the field
                if ((elem.charAt(index - 1) == '$') &&
                    (elem.charAt(index) == '{')) {
                    return false;
                }
            }
            if (notFound) {
                return false;
            }
        }
        // check whether text doesn't exist after ${Default}
        let result = /\$\{\s*Default\s*\}/.exec(elem);
        if (result != null) {
            let expectedLength = result.index + result[0].length;
            if (expectedLength != length) {
                return false;
            }
        }
        return true;
    },
    isValidForMelodyStamp(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (character == " ") {
                return false;
            }
            if (numericstr.indexOf(character) >= 0) {
                ;
            } else if (melodyStampStr.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidSttPhraseField(checkString) {
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if ((character == " ") || (character == "　")) {
                return false;
            }
            if (symbolstr5.indexOf(character) >= 0) {
                return false;
            }
        }
        return true;
    },
    isValidFullKana(checkString) {
        if ((checkString == null) || (checkString === "")) {
            return false;
        }
        for (let i = 0; i < checkString.length; i++) {
            let character = checkString.charAt(i);
            if (fullKana.indexOf(character) >= 0) {
                ;
            } else {
                return false;
            }
        }
        return true;
    },
    isValidFullWordCharacter(character) {
        for (let i = 0; i < character.length; i++) {
            let c = character.charCodeAt(i);
            // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
            // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
            if ((c >= 0x0 && c < 0x81) || (c === 0xf8f0) || (c >= 0xff61 && c < 0xffa0) || (c >= 0xf8f1 && c < 0xf8f4)) {
                // half word character existed.
                return false;
            }
        }
        return true;
    },
    isValidForBellName(checkString) {
        if ((checkString == null) || (checkString === "")) {
            return false;
        }
        if ((checkString.indexOf("\\") >= 0)
            || (checkString.indexOf(" ") >= 0)
            || (checkString.indexOf("　") >= 0)) {
            return false;
        }
        return true;
    },
    isValidForClientSettingName(checkString) {
        if (checkString.length > OBJECT_NAME_MAX) {
            return false;
        }
        if ((checkString == null) || (checkString == "")) {
            return false;
        }
        if ((checkString == "設定なし") || (checkString == "No setting")) {
            return false;
        }
        if ((checkString.indexOf("\\") >= 0)
            || (checkString.indexOf(" ") >= 0)
            || (checkString.indexOf("　") >= 0)) {
            return false;
        }
        return true;
    },
};
